import Image from 'next/image';
import { useMedia } from 'react-use';

import { SUPPORTED_CHAINS } from '@/constants/chain';

import { CheckmarkIcon } from '@/ui/Icons/CheckmarkIcon';
import { ResponsiveBR } from '@/ui/ResponsiveBR';

import { breakpoints } from '../../../styles/util';
import { StyledPrimaryCell, StyledH2, StyledParagraph } from '../utils';

const OPPORTUNITIES_TEXT_ITEMS = [
  'Trade any token for gas on a new network.',
  `Swap directly for any token across ${SUPPORTED_CHAINS.length} chains.`,
  "Tap into Matcha's aggregated liquidity across chains",
];

export const TokenOpportunitiesSection = () => {
  const isDesktop = useMedia(breakpoints.desktop, false);

  return (
    <div className="tablet:flex-row max-w-[1240px] mx-auto flex flex-col gap-5">
      <StyledPrimaryCell className="bg-token-gray-100 desktop:pl-15 desktop:pr-15 flex min-h-[444px] flex-[40%] flex-col justify-between bg-[url('/images/crosschain/vertical-lines.svg')] bg-left-bottom bg-no-repeat pr-10 pb-10">
        <div>
          <StyledH2>
            The best path
            <ResponsiveBR /> to new networks
          </StyledH2>
          <StyledParagraph className="tablet:max-w-[350px] mb-24 max-w-[200px]">
            Matcha does the hard work to find efficient and secure paths for your cross-chain
            trades.
          </StyledParagraph>
        </div>
        <Image
          className="max-w-full self-end"
          width={isDesktop ? 205 : 248}
          height={isDesktop ? 135 : 164}
          alt=""
          src="/images/crosschain/crosschain-trades.svg"
        />
      </StyledPrimaryCell>

      <StyledPrimaryCell className="bg-center-bottom bg-token-gray-100 desktop:pl-15 desktop:pr-15 flex flex-[60%] flex-col justify-start bg-gradient-to-br bg-[url('/images/crosschain/ring-lines-md.svg')] from-[rgba(252,252,253,0.10)] from-[28.82%] via-[#FCFCFD] via-[80.48%] bg-no-repeat bg-position-[center_100%] pr-11 pl-11">
        <StyledH2>
          Tokens and opportunities,
          <ResponsiveBR /> wherever they are
        </StyledH2>
        <ul className="text-token-gray-800 mt-4">
          {OPPORTUNITIES_TEXT_ITEMS.map((text) => (
            <li className="mt-4 flex items-center first:mt-0" key={text}>
              <div className="text-primitive-basic-white flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#02A863] from-[-13.93%] via-[rgba(2,168,99,0.49)] via-[112.7%] shadow-[0px_1px_3px_rgba(0,0,0,0.12),inset_0px_-1px_0px_rgba(0,0,0,0.16)]">
                <CheckmarkIcon />
              </div>
              <span className="text-body-lg text-token-gray-800 ml-3 font-normal">{text}</span>
            </li>
          ))}
        </ul>
        <div className="tablet:min-h-0 tablet:justify-between tablet:ml-2 desktop:ml-18 desktop:pt-2 flex h-full min-h-[220px] justify-around p-7.5">
          <div className="flex min-h-[220px] max-w-full">
            <Image
              width={80}
              height={75}
              alt=""
              src="/images/crosschain/token-green-check.svg"
              style={{ alignSelf: 'flex-end' }}
            />
          </div>
          <div className="flex min-h-[220px] max-w-full">
            <Image
              width={131}
              height={120}
              alt=""
              src="/images/crosschain/search-opportunities.svg"
            />
          </div>
        </div>
      </StyledPrimaryCell>
    </div>
  );
};
